import api from "@/utils/api";

/**
 * 알프레드(AI 계약상담) 관리자 모니터링 — api-admin /api/v1/alfred/* 호출.
 * 신규 관리자(admin-next)와 동일 백엔드. 응답은 ResponseResourceDto → res.data.data 가 payload.
 */
const state = {};
const mutations = {};

const actions = {
  /** 결제 고객 리스트 (이름/전화/이메일/회원번호 통합검색). */
  async acAlfredUsers(_, { page = 1, size = 100, search = null, type = "all" } = {}) {
    try {
      const res = await api.get(`/api/v1/alfred/users`, {
        params: { page, size, search: search || undefined, type },
      });
      return res.data.data; // { total, page, size, items }
    } catch (err) {
      return null;
    }
  },

  /** 회원 종합(회원정보 + 지갑 + 결제내역 + 상담요약). */
  async acAlfredOverview(_, userNo) {
    try {
      const res = await api.get(`/api/v1/alfred/users/${encodeURIComponent(userNo)}/overview`);
      return res.data.data;
    } catch (err) {
      return null;
    }
  },

  /** 회원 상담 세션 목록. */
  async acAlfredSessions(_, userNo) {
    try {
      const res = await api.get(`/api/v1/alfred/users/${encodeURIComponent(userNo)}/sessions`);
      return res.data.data;
    } catch (err) {
      return null;
    }
  },

  /** 세션 대화 전문. */
  async acAlfredSessionDetail(_, sessionSeq) {
    try {
      const res = await api.get(`/api/v1/alfred/sessions/${sessionSeq}`);
      return res.data.data; // { session, messages }
    } catch (err) {
      return null;
    }
  },

  /** 토큰 충전/차감(수동 보정). amount>0 충전, <0 차감. reason 필수. */
  async acAlfredAdjust(_, { userNo, reportSeq, amount, reason }) {
    const res = await api.post(`/api/v1/alfred/users/${encodeURIComponent(userNo)}/wallet/adjust`, {
      reportSeq,
      amount,
      reason,
    });
    return res.data.data;
  },

  /** 일일 보고 리스트(최신 날짜순). */
  async acAlfredBriefings(_, { page = 1, size = 60 } = {}) {
    try {
      const res = await api.get(`/api/v1/alfred/daily`, { params: { page, size } });
      return res.data.data; // { total, page, size, items }
    } catch (err) {
      return null;
    }
  },

  /** 일일 보고 상세(키 = YYYY-MM-DD 또는 briefing_seq). */
  async acAlfredBriefing(_, key) {
    try {
      const res = await api.get(`/api/v1/alfred/daily/${encodeURIComponent(key)}`);
      return res.data.data;
    } catch (err) {
      return null;
    }
  },

  /** [테스트 상담] 주소/지번/건물명으로 고객 리포트 검색(최신 20). */
  async acAlfredTestSearch(_, q) {
    try {
      const res = await api.get(`/api/v1/alfred/test/report-search`, { params: { q } });
      return res.data.data; // [{ cartSeq, address, addressJibun, buildingName, contractType, createDate }]
    } catch (err) {
      return null;
    }
  },

  /** [테스트 상담] 임의 고객 리포트(cartSeq)로 AI 질문. 세션/토큰 없는 일회성. */
  async acAlfredTestChat(_, { cartSeq, message, history = [] }) {
    const res = await api.post(`/api/v1/alfred/test/chat`, { cartSeq, message, history });
    return res.data.data; // { answer, model, usage, reportAddress }
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
};
